import { activeMenuMixin } from '@/mixins';
import debounce from 'lodash/debounce';
import mixins from 'vue-typed-mixins';
import menus from '@/menus';
const Tabs = () => import(/* webpackChunkName: "Tabs" */ '@/components/Tabs/Tabs.vue');
const Tab = () => import(/* webpackChunkName: "Tab" */ '@/components/Tabs/Tab.vue');
export default mixins(activeMenuMixin).extend({
    components: {
        Tabs,
        Tab,
    },
    props: {
        value: {
            type: Number,
            default: 0,
        },
        sticky: {
            type: Boolean,
            default: true,
        },
        centerActive: {
            type: Boolean,
            default: true,
        },
        // items: {
        //   type: Array as PropType<MenuItem[]>,
        //   default: () => [],
        // },
    },
    computed: {
        isFaqPage() {
            return this.$route.name === 'faq';
        },
        items() {
            return menus;
        },
    },
    watch: {
        value: {
            handler(val) {
                this.activeMenu = val;
            },
        },
        activeTab(val) {
            this.$emit('update:activeTab', val);
        },
        '$route.name': {
            immediate: true,
            handler(val) {
                if (val === 'faq') {
                    this.activeMenu = 6;
                }
            },
        },
    },
    mounted() {
        this.onScroll();
        window.addEventListener('scroll', this.onScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll);
    },
    methods: {
        onScroll: debounce(function () {
            if (this.$route.name === 'home') {
                const top = window.pageYOffset || document.documentElement.scrollTop;
                // console.log(top, this.activeMenu, this.scrollHash);
                // account lookup
                if (top >= 0) {
                    this.activeMenu = 0;
                }
                // about
                if (top >= 1000) {
                    this.activeMenu = 1;
                }
                // platform
                if (top >= 1500) {
                    this.activeMenu = 2;
                }
                // cara aktivasi
                if (top >= 2100) {
                    this.activeMenu = 3;
                }
                // webinar
                if (top >= 2800) {
                    this.activeMenu = 4;
                }
                // pernyataan pemerintah
                if (top >= 3000) {
                    this.activeMenu = 5;
                }
                // faq
                if (top > 3800) {
                    this.activeMenu = 6;
                }
            }
        }, 0),
    },
});
